import styled from 'styled-components'
export const ContainerLogo = styled.div`
    max-width: 300px;
    max-height: 100px;

`
